import countryIsInEurope from './countryIsInEurope'

const NON_EUROPE_SHIPPING = 50

const getShippingPrice = (countryCode, defaultPrice) => {
  if (!countryCode) return defaultPrice
  return countryIsInEurope(countryCode) ? defaultPrice : NON_EUROPE_SHIPPING
}

export default getShippingPrice
